<template>
    <div class="product-rating">
        <div class="back-stars">
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>
            <i class="fa fa-star"></i>

            <div class="front-stars" :style="{ width: normalizedRatingPercent + '%' }">
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
            </div>
        </div>

        <span class="rating-count" v-if="hasReviewCount">({{ this.reviewCount }})</span>
    </div>
</template>

<script>
    export default {
        props: ['ratingPercent', 'reviewCount'],

        computed: {
            normalizedRatingPercent() {
                if (Number(this.reviewCount) <= 0) {
                    return 0;
                }

                const parsedValue = Number(this.ratingPercent);

                if (!Number.isFinite(parsedValue) || parsedValue <= 0) {
                    return 0;
                }

                return Math.min(parsedValue, 100);
            },

            hasReviewCount() {
                return this.reviewCount !== undefined && this.reviewCount !== null;
            },
        },
    };
</script>
